/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  DetailsHeader,
  DetailsList,
  DetailsListLayoutMode,
  DetailsRow,
  FontIcon,
  IColumn,
  IComboBoxOption,
  Icon,
  IconButton,
  IDetailsColumnProps,
  IDetailsHeader,
  IDetailsHeaderStyles,
  IDetailsListProps,
  IDetailsListStyleProps,
  IDetailsListStyles,
  IDetailsRowBaseProps,
  IDetailsRowStyles,
  IGroup,
  IGroupHeaderProps,
  IRawStyle,
  IRenderFunction,
  Link,
  mergeStyleSets,
  PanelType,
  SelectionMode,
  Stack,
  TooltipHost,
} from "@fluentui/react";
import { useCallback, useEffect, useState } from "react";
import { PanelGenerico } from "../../../components/generic/PanelGenerico";
import {
  IIPercItemsColum,
  IIPercPeligroDetalle,
  IIpercPeligroPost,
  INuevoIpercBase,
} from "../../../Interfaces/IIpercBase";
import IPERCService from "../../../services/IPERCService";
import { _onRenderDetailsHeader } from "../../../utils/helpers/checkListHelpers";
import { _onRenderHeaderAllheight } from "../../../utils/helpers/helpers";
import { useBoolean } from "@fluentui/react-hooks";
import { IPERCPeligros } from "../../../Interfaces/IIPERC";
import EditarRiesgo from "./EditarRiego";
import COLORES from "../../../utils/theme/colores";
import themeBase from "../../../utils/theme/themeBase";
import HeaderTable from "../../../components/generic/HeaderTable";
import NuevoPeligro from "./NuevoPeligro";
import { IHeaderTitlesText } from "../../../Interfaces/IPanel";
import HelpersIpercBase from "../../../utils/helpers/HelpersIpercBase";
import { mode } from "d3";

function DefinirNuevoIpercBase(props: INuevoIpercBase) {
  // const [procesos, setProcesos] = useState<IComboBoxOption[]>([]);
  // const [actividades, setActividades] = useState<IComboBoxOption[]>([]);
  const [ArrayItems, setArrayItems] = useState<any[]>([]);
  const [gruposItems, setGruposItems] = useState<IGroup[]>([]);

  // const [peligrosD, setPeligrosD] = useState<IPERCPeligros>();
  const [PeligroDetalle, setPeligroDetalle] = useState<IIPercPeligroDetalle>();

  const [PeligroModelPUT, setPeligroModelPUT] =
    useState<IIPercPeligroDetalle>();
  const _PeligroModelPUT = setPeligroModelPUT as (value) => void;

  const [
    isOpenEditarRiesgo,
    { setTrue: openEditarRiesgo, setFalse: dismissEditarRiesgo },
  ] = useBoolean(false);

  const [isLoadingData, { setTrue: loadingData, setFalse: notLoadingData }] =
    useBoolean(false);
  const [model, setModel] = useState<IIpercPeligroPost | null>(null);
  const [disableFormNuevoPeligro, setDisableFormNuevoPeligro] = useState(true);

  const DataProcesos = useCallback(() => {
    IPERCService.listaProcesos()
      .then((res) => {
        let d: any[] = res.data;
        let o: IComboBoxOption[] = [];
        // eslint-disable-next-line array-callback-return
        d.map((val) => {
          o.push({
            key: val.procesoId,
            text: val.nombre,
          });
        });
        // setProcesos(o)
      })
      .catch((e: Error) => {
        alert(e.message);
      });
  }, []);

  const DataActividades = useCallback(() => {
    IPERCService.comboActividades("")
      .then((res) => {
        // console.log(res.data.data)
        let d: any[] = res.data.data;
        let o: IComboBoxOption[] = [];
        // eslint-disable-next-line array-callback-return
        d.map((val) => {
          o.push({
            key: val.id,
            text: val.nombre,
          });
        });
        // setActividades(o)
      })
      .catch((e: Error) => {
        alert(e.message);
      });
  }, []);

  const dataIpercUnico = (actividadId?: string) => {
    setGruposItems([]);
    notLoadingData();
    if (actividadId)
      IPERCService.IpercUnico(actividadId)
        .then((res) => {
          // console.log("Res: ", res.data.listaPeligros)
          let p: IPERCPeligros[] = res.data.listaPeligros;
          let pAux: IGroup[] = [];
          let AuxArray: IIPercItemsColum[] = [];
          let start = 0;
          // eslint-disable-next-line array-callback-return
          p.map((valP, pIndex) => {
            let _PeligroId = valP.peligroId;
            let _Peligro = valP.nombre;
            valP.detalles.forEach((valR, Rindex) => {
              let medida = valR.medidas.nombre;
              let _medidaId = valR.medidas.medidasId;
              let riesgo = valR.riesgos.nombre;
              let _riesgoId = valR.riesgos.riesgoId;

              let evaluacionRA = "",
                evaluacionRM = "",
                evaluacionRB = "";
              let evaluacionMA = "",
                evaluacionMM = "",
                evaluacionMB = "";
              valR.riesgos.evaluaciones.forEach((valE, Eindex) => {
                switch (valE.codigo) {
                  case "01":
                    evaluacionRA = valE.valor;
                    break;
                  case "02":
                    evaluacionRM = valE.valor;
                    break;
                  case "03":
                    evaluacionRB = valE.valor;
                    break;
                  default:
                    console.log(
                      "Riesgos : ",
                      pIndex,
                      Rindex,
                      Eindex,
                      valP.nombre,
                      valR.riesgos.nombre,
                      valE.valor
                    );
                    break;
                }
              });
              valR.medidas.evaluaciones.forEach((valM, Mindex) => {
                switch (valM.codigo) {
                  case "01":
                    evaluacionMA = valM.valor;
                    break;
                  case "02":
                    evaluacionMM = valM.valor;
                    break;
                  case "03":
                    evaluacionMB = valM.valor;
                    break;
                  default:
                    console.log(
                      "Medidas : ",
                      pIndex,
                      Rindex,
                      Mindex,
                      valP.nombre,
                      valR.medidas.nombre,
                      valM.valor
                    );
                    break;
                }
              });
              AuxArray.push({
                peligro: _Peligro,
                peligroId: _PeligroId,
                medida: medida,
                medidaId: _medidaId,
                riesgo: riesgo,
                reiegoId: _riesgoId,
                A: evaluacionRA,
                M: evaluacionRM,
                B: evaluacionRB,
                MA: evaluacionMA,
                MM: evaluacionMM,
                MB: evaluacionMB,
              });
            });
            setArrayItems([...AuxArray]);

            pAux.push({
              key: valP.peligroId,
              name: valP.nombre,
              startIndex: start,
              count: valP.detalles.length,
              level: pIndex + 1,
              // data: valP.detalles
            });
            start = start + valP.detalles.length;
          });
          setGruposItems(pAux);
          loadingData();
        })
        .catch((e: Error) => {
          alert(e.message);
          notLoadingData();
        });
  };

  useEffect(() => {
    DataProcesos();
    DataActividades();
  }, []);

  useEffect(() => {
    dataIpercUnico(props.actividadId);
  }, [props.actividadId]);

  useEffect(() => {
    // console.log("PUT", PeligroModelPUT)
  }, [PeligroModelPUT]);

  const ActulizarPeligro = () => {
    if (PeligroModelPUT)
      IPERCService.ActulizarPeligro(PeligroModelPUT)
        .then((res) => {
          dismissEditarRiesgo();
          dataIpercUnico(props.actividadId);
        })
        .catch((e: Error) => {
          alert(e.message);
        });
  };

  useEffect(() => {
    validarFormNuevoPeligro();
  }, [model]);

  const _crearPeligro = () => {
    console.log("Crear :");
    setDisableFormNuevoPeligro(true);

    IPERCService.AgregarPeligro(model!)
      .then((res) => {
        alert("ok");

        props.onDismissNuevoPeligro();
        dataIpercUnico(props.actividadId);
      })
      .catch((e: Error) => {
        alert(e.message);
      });
    props.onDismissNuevoPeligro();
  };

  const onRenderHeader = (props?: IGroupHeaderProps): JSX.Element | null => {
    if (props) {
      const toggleCollapse = (): void => {
        props.onToggleCollapse!(props.group!);
      };
      const headerAndFooterStyles: IRawStyle = {
        minWidth: 300,
        width: "available",
        minHeight: 30,
        lineHeight: 30,
        paddingLeft: 15,
        fontWeight: "semibold",
        fontSize: 10,
        backgroundColor: "#f3f2f1",
      };
      const classNames = mergeStyleSets({
        header: [headerAndFooterStyles],
      });
      return (
        <div className={classNames.header}>
          <div className="ms-Grid" dir="ltr">
            <div className="ms-Grid-row" style={{ width: "100%" }}>
              <div className="ms-Grid-col ms-sm11 ms-md11 ms-lg11">
                <Link onClick={toggleCollapse}>
                  {props.group!.isCollapsed ? (
                    <Icon
                      iconName="CaretSolidDown"
                      ariaLabel="arial label"
                      style={{ color: "GrayText" }}
                    />
                  ) : (
                    <Icon
                      iconName="CaretSolidRight"
                      ariaLabel="arial label"
                      style={{ color: "GrayText" }}
                    />
                  )}
                </Link>
                {props.group!.name.toUpperCase()}
              </div>
              <div className="ms-Grid-col ms-sm1 ms-md1 ms-lg1">
                <IconButton
                  iconProps={{ iconName: "Slider" }}
                  aria-label="add"
                />
              </div>
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  const _onRenderRow: IDetailsListProps["onRenderRow"] = (props) => {
    const customStyles: Partial<IDetailsRowStyles> = {};
    if (props) {
      // customStyles.root = {
      //     margin: '5px 0 5px 0',
      //     padding: '5px 0 5px 0',
      //     borderRadius: '5px',
      //     minHeight: '50px',
      //     maxHeight:'50px',
      //     backgroundColor: COLORES.Bases.BackgroundToDo,
      //     border: themeBase.theme.effects.elevation4
      // };
      customStyles.fields = {
        textAlign: "start",
        alignItems: "end",
      };
      return <DetailsRow {...props} styles={customStyles} />;
    }
    return null;
  };

  const _onRenderHeaderColum = (
    colProps?: IDetailsColumnProps,
    defaultRender?: IRenderFunction<IDetailsColumnProps>
  ): JSX.Element | null => (
    <Stack
      style={{
        color: COLORES.IPERC.whiteNumber,
        fontWeight: "bold",
        fontSize: "11px",
      }}
    >
      {colProps?.column.name}{" "}
    </Stack>
  );

  const RenderTitleIpercA = (
    colProps?: IDetailsColumnProps,
    defaultRender?: IRenderFunction<IDetailsColumnProps>
  ): JSX.Element | null => (
    <div style={{ color: COLORES.IPERC.number, fontWeight: "bold" }}>
      {colProps?.column.name}
    </div>
  );

  const RenderTitleIpercM = (
    colProps?: IDetailsColumnProps,
    defaultRender?: IRenderFunction<IDetailsColumnProps>
  ): JSX.Element | null => (
    <Stack style={{ color: COLORES.IPERC.number, fontWeight: "bold" }}>
      {colProps?.column.name}
    </Stack>
  );

  const RenderTitleIpercB = (
    colProps?: IDetailsColumnProps,
    defaultRender?: IRenderFunction<IDetailsColumnProps>
  ): JSX.Element | null => (
    <Stack style={{ color: COLORES.IPERC.number, fontWeight: "bold" }}>
      {colProps?.column.name}
    </Stack>
  );

  const ItemRenderAux = (text: string) => (
    <Stack
      className="ms-fontSize-10"
      horizontal
      horizontalAlign="space-between"
      verticalAlign="center"
    >
      {text}
    </Stack>
  );
  const ItemRenderIper = (text: string) => {
    if (text == "")
      return (
        <FontIcon
          iconName="ToggleBorder"
          style={{ color: COLORES.Icons.delete }}
        />
      );
    return (
      <span style={{ color: COLORES.IPERC.number, fontWeight: "bold" }}>
        {text}
      </span>
    );
  };

  const _onRenderDetailsFooter: IDetailsListProps["onRenderDetailsFooter"] = (
    props
  ) => {
    if (props) {
      if (gruposItems.length === 0)
        return (
          <h4
            style={{
              textAlign: "center",
              verticalAlign: "center",
              background: themeBase.colors_Bases.HeaderGroup,
              width: "90%",
              padding: 10,
            }}
          >
            Sin Datos
          </h4>
        );
      if (ArrayItems.length === 0) return null;
    }
    return null;
  };

  const _onRenderDetailsHeader: IDetailsListProps["onRenderDetailsHeader"] = (
    props
  ) => {
    const customStyles: Partial<IDetailsListStyles> = {};
    customStyles.root = {
      alignContent: "center",
      background: "#ddd",
    };
    if (props) {
      return <DetailsHeader {...props} styles={customStyles} />;
    }
    return null;
  };

  const _columnsDetalleItems = [
    {
      key: "peligro",
      name: "Peligro",
      fieldName: "peligro",
      minWidth: 50,
      maxWidth: 50,
      onRender: (item: IIPercItemsColum) => <></>,
      // isResizable: true,
      // isMultiline: true,
      // onRender: (item: IIPercItemsColum) => (ItemRenderAux(item.peligro)),
      // onRenderHeader: _onRenderHeaderColum,
    },
    {
      key: "riesgo",
      name: "Riesgo",
      fieldName: "riesgo",
      minWidth: 150,
      maxWidth: 200,
      isResizable: true,
      isMultiline: true,
      onRender: (item: IIPercItemsColum) => ItemRenderAux(item.riesgo),
      onRenderHeader: _onRenderHeaderColum,
      styles: {
        root: {
          background: COLORES.IPERC.Red,
          selectors: { ":hover": { background: COLORES.IPERC.Red } },
        },
      },
    },
    {
      key: "valorA",
      name: "A",
      fieldName: "valorA",
      minWidth: 15,
      maxWidth: 15,
      isResizable: true,
      onRender: (item: IIPercItemsColum) => ItemRenderIper(item.A),
      onRenderHeader: RenderTitleIpercA,
      styles: { root: { background: COLORES.IPERC.A } },
    },
    {
      key: "M",
      name: "M",
      fieldName: "M",
      minWidth: 15,
      maxWidth: 15,
      isResizable: true,
      onRender: (item: IIPercItemsColum) => ItemRenderIper(item.M),
      onRenderHeader: RenderTitleIpercM,
      styles: { root: { background: COLORES.IPERC.M } },
    },
    {
      key: "B",
      name: `B`,
      fieldName: "B",
      minWidth: 15,
      maxWidth: 15,
      isResizable: true,
      onRender: (item: IIPercItemsColum) => ItemRenderIper(item.B),
      onRenderHeader: RenderTitleIpercB,
      styles: { root: { background: COLORES.IPERC.B } },
    },
    {
      key: "medidascontrol",
      name: "Medidas de Control",
      fieldName: "medidascontrol",
      minWidth: 200,
      maxWidth: 250,
      isResizable: true,
      isMultiline: true,
      onRender: (item: IIPercItemsColum) => ItemRenderAux(item.medida),
      onRenderHeader: _onRenderHeaderColum,
      styles: {
        root: {
          background: COLORES.IPERC.Red,
          selectors: { ":hover": { background: COLORES.IPERC.Red } },
        },
      },
    },
    {
      key: "ma",
      name: "A",
      fieldName: "ma",
      minWidth: 15,
      maxWidth: 15,
      isResizable: true,
      onRender: (item: IIPercItemsColum) => ItemRenderIper(item.MA),
      onRenderHeader: RenderTitleIpercA,
      styles: { root: { background: COLORES.IPERC.A } },
    },
    {
      key: "mm",
      name: `M`,
      fieldName: "mm",
      minWidth: 15,
      maxWidth: 15,
      isResizable: true,
      onRender: (item: IIPercItemsColum) => ItemRenderIper(item.MM),
      onRenderHeader: RenderTitleIpercM,
      styles: { root: { background: COLORES.IPERC.M } },
    },
    {
      key: "mb",
      name: `B`,
      fieldName: "mb",
      minWidth: 15,
      maxWidth: 15,
      isResizable: true,
      onRender: (item: IIPercItemsColum) => ItemRenderIper(item.MB),
      onRenderHeader: RenderTitleIpercB,
      styles: { root: { background: COLORES.IPERC.B } },
    },
    {
      key: "op",
      name: "",
      fieldName: "op",
      minWidth: 30,
      maxWidth: 30,
      isResizable: true,
      onRender: (item: IIPercItemsColum) => (
        <Stack horizontalAlign="center">
          <div>
            <TooltipHost content={`Editar`}>
              <Icon
                iconName="edit"
                className={themeBase.classNamesIcon.iconFont}
                style={{ color: COLORES.Bases.primary }}
                onClick={() => {
                  setPeligroDetalle({ ...getDetalle(item) });
                  openEditarRiesgo();
                }}
              />
            </TooltipHost>
            {/* <TooltipHost content={`Quitar`}>
                            <Icon
                                iconName="delete"
                                // className="ms-fontSize-14"
                                className={themeBase.classNamesIcon.iconFont}
                                style={{ cursor: 'pointer', color: COLORES.Icons.delete }}
                            />
                        </TooltipHost> */}
          </div>
        </Stack>
      ),
    },
  ];

  const validarFormNuevoPeligro = () => {
    if (model == null) setDisableFormNuevoPeligro(true);
    if (model !== null) {
      if (
        model.actividadId &&
        model.peligro &&
        model.riesgo &&
        model.riesgo.nombre &&
        model.riesgo.indicador &&
        model.riesgo.codigoOpcion &&
        model.medida &&
        model.medida.nombre &&
        model.medida.indicador &&
        model.medida.codigoOpcion
      ) {
        setDisableFormNuevoPeligro(false);
      } else {
        setDisableFormNuevoPeligro(true);
      }
    }
  };

  return (
    <>
      <HeaderTable
        title="IPERC"
        subTitle="Gestión de IPERC Base"
        horizontalAlign="end"
        iconName="Dialpad"
      />
      <div className="ms-Grid" dir="ltr">
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-lg12">
            {HelpersIpercBase.LoadingData(isLoadingData)}
            <DetailsList
              items={ArrayItems}
              groups={gruposItems}
              columns={_columnsDetalleItems}
              selectionMode={SelectionMode.none}
              // onRenderDetailsHeader={_onRenderDetailsHeader}
              onRenderDetailsFooter={_onRenderDetailsFooter}
              // onRenderRow={_onRenderRow}
              layoutMode={DetailsListLayoutMode.justified}
              // groupProps={groupedListProps}
              groupProps={{ onRenderHeader: onRenderHeader }}
              compact={true}
              styles={_onRenderHeaderAllheight}
            />
          </div>
        </div>
      </div>

      {/* Editar Peligro de Actividad */}
      <PanelGenerico
        isOpen={isOpenEditarRiesgo}
        onDismiss={dismissEditarRiesgo}
        HeaderTitlesText={{
          title: "Editar Riesgo",
          subTitle: "Edite valores de riesgo",
        }}
        enabledHeader
        registrar={ActulizarPeligro}
        objectRenderBodyHelp={PeligroModelPUT}
        cancelar={dismissEditarRiesgo}
      >
        <EditarRiesgo
          objetoDetalle={PeligroDetalle!}
          getObjetoPUT={_PeligroModelPUT}
        />
      </PanelGenerico>

      {/* Nuevo Peligro de Actividad */}
      <PanelGenerico
        isOpen={props.isOpenNuevoPeligro}
        onDismiss={props.onDismissNuevoPeligro}
        enabledHeader
        HeaderTitlesText={HeaderPanelTiles}
        iconHeaderName="ProcessMetaTask"
        enabledIconHeader={false}
        registrar={_crearPeligro}
        cancelar={props.onDismissNuevoPeligro}
        objectRenderBodyHelp={model}
        disabledRegister={disableFormNuevoPeligro}
      >
        {/* <pre>{JSON.stringify(disableFormNuevoPeligro, null, 2)}</pre>

        <pre>{JSON.stringify(model, null, 2)}</pre> */}
        <NuevoPeligro
          ModelPOST={setModel as (arg) => void}
          actividadId={props.actividadId}
        />
      </PanelGenerico>
    </>
  );
}

export default DefinirNuevoIpercBase;

function _getIndicador(A: string, M: string, B: string): [number, string] {
  if (A) return [parseInt(A), "01"];
  if (M) return [parseInt(M), "02"];
  if (B) return [parseInt(B), "03"];

  return [0, "0"];
}

const HeaderPanelTiles: IHeaderTitlesText = {
  title: "Nuevo Peligro",
  subTitle: "Complete los campos para registar proceso",
};

function getDetalle(item: IIPercItemsColum) {
  return {
    peligroId: item.peligroId,
    nombre: item.peligro,
    riegos: {
      nombre: item.riesgo,
      riesgoId: item.reiegoId,
      evaluaciones: {
        codigo: _getIndicador(item.A, item.M, item.B)[1],
        id: _getIndicador(item.A, item.M, item.B)[1],
        valor: _getIndicador(item.A, item.M, item.B)[0].toString(),
      },
    },
    medidas: {
      nombre: item.medida,
      medidasId: item.medidaId,
      evaluaciones: {
        codigo: _getIndicador(item.MA, item.MM, item.MB)[1],
        id: _getIndicador(item.MA, item.MM, item.MB)[1],
        valor: _getIndicador(item.MA, item.MM, item.MB)[0].toString(),
      },
    },
  };
}
